<template>
  <div class="p-3">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <label> Para realizar el ajuste solicitado, debe seleccionar la descripción del cambio y quien solicita el
      ajuste</label>
    <validacion/>
    <b-table
        :items="listaTrt"
        :fields="titulos"
        thead-tr-class="columnas"
        class="mt-3 text-center"
        :key="forceUpdate"
        responsive
    >
      <template v-slot:cell(nombreDiente)="row">
        <div v-if="row.item.nombreDiente === null">
          <v-select
              style="width: 130%"
              label="nombre"
              v-model="row.item.od"
              :options="listaDientes"
              :reduce="(variable) => variable.idDiente"
              id="idDiente"
          ></v-select>
        </div>
        <div v-else>
          {{ row.item.nombreDiente }}
        </div>
      </template>
      <template v-slot:cell(ses)="row">
        {{ row.item.sesActual }}/{{ row.item.ses }}
      </template>
      <template v-slot:cell(precioOriginal)="row">
        {{ row.item.precioOriginal | moneda }}
      </template>
      <template v-slot:cell(precio)="row">
        <b-form-input type="number" v-model.number="row.item.precio"
                      :disabled="!row.item.idMotivo && !row.item.idEmpleado">
        </b-form-input>
      </template>
      <template v-slot:cell(descuento)="row">
        <b-form-input type="text" maxLength="3" @keypress="onlyNumber" v-model="row.item.descuento"
                      :disabled="!row.item.idMotivo && !row.item.idEmpleado">
        </b-form-input>
      </template>
      <template v-slot:cell(descuentoPromocion)="row">
        <b-form-input type="text" maxLength="3" @keypress="onlyNumber($event)" v-model="row.item.descuentoPromocion"
                      :disabled="!row.item.idMotivo && !row.item.idEmpleado">
        </b-form-input>
      </template>
      <template v-slot:cell(total)="row">
        {{ totalRes(row.index) | moneda }}
      </template>
      <template v-slot:cell(motivo)="row">
        <b-form-group style="width: 200px;">
          <v-select
              v-model="row.item.idMotivo"
              :options="motivosFiltro"
              :reduce="(val) => val.idMotivo"
              @input="leerDato(row.item)"
              label="descripcion"
              placeholder="Selecciona un motivo"
              required
              :filterable="false"
              @search="filtroMotivos"
              :state="(!entroGuardar || (row.item.registroValido==null || row.item.registroValido))
              || (row.item.idMotivo != null && row.item.idMotivo > 0)"
          >
          </v-select>
          <b-form-invalid-feedback
              :state="(!entroGuardar || (row.item.registroValido==null || row.item.registroValido))
              || (row.item.idMotivo != null && row.item.idMotivo > 0)">
            Debe seleccionar un motivo de cambio
          </b-form-invalid-feedback>
        </b-form-group>


      </template>
      <template v-slot:cell(nombreEmpleado)="row">
        <b-form-group style="width: 200px;">
          <v-select
              v-model="row.item.idEmpleado"
              :options="empleadosOpciones"
              :reduce="(val) => val.idEmpleado"
              label="nombreEmpleado"
              placeholder="Selecciona empleado"
              :filterable="false"
              @search="filtroEmpleados"
              required
              :state="(!entroGuardar || (row.item.registroValido==null || row.item.registroValido))
              || (row.item.idEmpleado != null && row.item.idEmpleado > 0)">
          >
          </v-select>
          <b-form-invalid-feedback
              :state="(!entroGuardar || (row.item.registroValido==null || row.item.registroValido))
              || (row.item.idEmpleado != null && row.item.idEmpleado > 0)">
            Debe de seleccionar un empleado
          </b-form-invalid-feedback>
        </b-form-group>
      </template>

      <template v-slot:cell(planPaciente)="row">
        <b-form-group style="width: 200px;">
          <b-form-select
            id="idPlan" name="nombre" placeholder="Selecciona un plan"
            v-model="row.item.idPlan"
            :options="lstPlanesPaciente"
            value-field="id"
            text-field="nombre"
            :state="(!entroGuardar || (row.item.registroValido==null || row.item.registroValido))
              || (row.item.idPlan != null && row.item.idPlan > 0)">
          </b-form-select>
          <b-form-invalid-feedback
              :state="(!entroGuardar || (row.item.registroValido==null || row.item.registroValido))
              || (row.item.idPlan != null && row.item.idPlan > 0)">
            Debe de seleccionar un plan del paciente
          </b-form-invalid-feedback>
        </b-form-group>
      </template>
    </b-table>

    <b-row class="text-center">
      <b-col v-if="enviando" disabled>
        <b-button variant="primary" disabled>
          <b-spinner small></b-spinner>
          Cargando...
        </b-button>
      </b-col>
      <b-col v-else>
        <b-button variant="outline-primary" v-on:click="validarFormulario">
          Guardar
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VueNotifications from "vue-notifications";

export default {
  name: "PrecioTratamientoSesion",
  props: {
    tratamientos: {
      type: Array,
      required: true,
    },
    empleados: Array,
    motivos: Array,
    lstPlanesPaciente: Array
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    clinicaSeleccionada: null,
    lstMotivos: [],
    lstEmpleados: [],
    empleadosOpciones: [],
    motivosFiltro: [],
    descuentoOriginal: null,
    titulos: [
      {key: "tratamiento", label: "Tratamiento"},
      {key: "nombreDiente", label: "Diente"},
      {key: "ses", label: "Sesión"},
      {key: "precioOriginal", label: "Precio Total"},
      {key: "precio", label: "Precio orig sesión"},
      {key: "descuento", label: "% Desc"},
      {key: "descuentoPromocion", label: "% Desc Promo"},
      {key: "total", label: "Precio sesión"},
    ],
    listaTrt: [],
    enviando: false,
    forceUpdate: false,
    listaDientes: [],
    idDiente: null,
    guardoOd: false,
    objValidar: null,
    formularioValido:true,
    entroGuardar:false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.clinicaSeleccionada = this.$localStorageService.getIdClinica();
    this.obtenerEmpleados();
    this.listaTrt = this.tratamientos;
    this.listaTrt = this.listaTrt.map((e) => ({
      total: 0,
      descuentoOriginal: e.descuento,
      ...e,
    }));
    this.obtenerListaDientes();

    if (this.lstPlanesPaciente != null && this.lstPlanesPaciente.length > 0) {
      this.titulos.push({"key": "planPaciente", "label": "Plan"});
    }

    this.titulos.push({"key": "motivo", "label": "Descripción de Cambio"});
    this.titulos.push({"key": "nombreEmpleado", "label": "PERSONA QUE AUTORIZA"});

  },
  watch: {
    listaTrt: function () {
      return this.listaTrt;
    }
  },
  methods: {
    obtenerListaDientes() {
      this.$http.get(this.$api + "catalogos/listaDientes/ordenados").then(response => {
        this.listaDientes = response.data.data;
        this.listaDientes.forEach(r => {
          r.nombre = r.numeroDiente + '-' + r.nombre
        })
      })
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      }
    },
    leerDato(val) {
      if (val.idMotivo == null) {

        let index = this.listaTrt.findIndex(x => x === val);
        delete this.listaTrt[index].descuento
        this.listaTrt[index].descuento = this.listaTrt[index].descuentoOriginal
        delete this.listaTrt[index].descuentoPromocion
        this.listaTrt[index].descuentoPromocion = this.listaTrt[index].descuentoOriginal
        this.forceUpdate = !this.forceUpdate
      }
    },
    totalRes(registro) {
      const monto = this.listaTrt[registro].precio;

      const promo = (monto * this.listaTrt[registro].descuento) / 100;

      const descPromo = Math.ceil((Math.ceil((monto - promo)) * this.listaTrt[registro].descuentoPromocion) / 100);

      this.listaTrt[registro].total = Math.ceil(Math.ceil((monto - promo)) - descPromo);

      return Math.ceil(Math.ceil((monto - promo)) - descPromo);
    },
    validarFormulario() {
      this.entroGuardar = true
      this.formularioValido = true;
      let isFormularioVacio = 0;
      this.listaTrt.forEach(element => {

        element.registroValido = true;

        if (element.nombreDiente == null && element.od !== null) {
          this.guardoOd = true;
        }

        if ((element.idMotivo != null && element.idEmpleado == null)
            || (element.idMotivo == null && element.idEmpleado != null) || element.od == null) {
          this.formularioValido = false;
          element.registroValido = false;
          element.registroValidoff= " if ((element.idMotivo != null && element.idEmpleado == null)";
        } else if (element.idMotivo == null && element.idEmpleado == null) {
          isFormularioVacio++;
        }

        if (element.descuento > 100 || element.descuentoPromocion > 100) {
          this.formularioValido = false;
          element.registroValido = false;
          element.registroValidoff= " if (element.descuento > 100 || element.descuentoPromocion > 100) {";
        }

        if (element.registroValido
            && this.lstPlanesPaciente != null && this.lstPlanesPaciente.length > 0
            && (element.idPlan == null || element.idPlan < 1)) {
          this.formularioValido = false;
          element.registroValido = false;
          element.registroValidoff= " && this.lstPlanesPaciente != null && this.lstPlanesPaciente.length > 0";
        }
      });

      let formularioVacio = this.listaTrt.length == isFormularioVacio

      if (this.formularioValido && !formularioVacio) {
        this.guardarTratamientos();
      } else if (!this.formularioValido) {
        this.$swal.fire({
          icon: "error",
          title: "Aviso",
          text: "Por favor verifique la información del formulario",
        });
      } else if (formularioVacio) {
        this.$swal.fire({
          icon: "error",
          title: "Aviso",
          text: "No se encontró información para guardar",
        });
      }
    },
    mandarServicioGuardar() {
      this.enviando = true;
      const url = this.$api + "sesion/tratamientos/precios";

      this.empleados.forEach(f => f.idEmpleado)
      let nuevaLista = [];
      this.listaTrt.forEach((i) => {
        nuevaLista.push({
          id: i.id,
          od: i.od,
          precioOriginal: i.precio,
          precio: i.total,
          descuento: i.descuento,
          descuentoPromocion: i.descuentoPromocion,
          idEmpleado: i.idEmpleado,
          idMotivoAjustePrecio: i.idMotivo,
          idUsuario: this.$localStorageService.getIdUsuario(),
          nombreDiente: i.nombreDiente,
          idPlan: i.idPlan,
        });
      });

      this.$http
          .put(url, nuevaLista)
          .then((response) => {
            if (response.status === 200) {
              this.$swal({
                icon: "success",
                text: "Se envio la información correctamente",
                confirmButtonText: "OK",
                confirmButtonColor: "#0e6ba9",
              });

              setTimeout(() => location.reload(), 2000);
            }
          })
          .catch((err) => {
            this.errorEnvio(err);
          })
          .finally(() => {
            this.enviando = false;
          });
    },

    guardarTratamientos() {
      if (this.guardoOd) {
        this.$swal.fire({
          text: "¿Estás seguro de la asignación del OD? Esta acción no se podrá revertir.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "No estoy seguro/a",
          showLoaderOnConfirm: true,
          preConfirm: () => {
            this.mandarServicioGuardar();
          }
        })
      } else {
        this.mandarServicioGuardar();
      }

    },
    filtroEmpleados(busqueda, loading) {
      loading(true)
      let seach = busqueda.trim()
      if (busqueda === '') {
        this.empleadosOpciones = JSON.parse(JSON.stringify(this.empleados))
      }
      this.empleadosOpciones = this.empleados.filter(em => {
            return em.nombreEmpleado.toLowerCase().includes(seach.toLowerCase())
          }
      )
      loading(false)
    },
    obtenerEmpleados() {
      const params = {
        idClinica: this.clinicaSeleccionada
      }
      this.$http.post(this.$api + "sesion/listaPerfilEmpleadosPorClinica", params).then((response) => {
        if (response.data.data) {
          this.lstEmpleados = response.data.data
          this.empleadosOpciones = this.lstEmpleados
        }
      }).catch(() => {
        this.mostrarMensajeError("Ocurrio un error al traer los registros.");
      })
      this.$http.get(this.$api + "sesion/listaMotivosAjustesPrecio").then((response) => {
        this.lstMotivos = response.data.data
        this.motivosFiltro = this.lstMotivos;
      }).catch(() => {
        this.mostrarMensajeError("Ocurrio un error al traer los registros.");
      })

    },
    filtroMotivos(busqueda, loading) {

      loading(true)
      let seach = busqueda.trim()
      if (busqueda === '') {
        this.motivosFiltro = JSON.parse(JSON.stringify(this.empleados))
      }
      this.motivosFiltro = this.motivos.filter(m => {
            return m.descripcion.toLowerCase().includes(seach.toLowerCase())
          }
      )
      loading(false)
    }
  },
  notifications: {
    errorEnvio: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al enviar la información",
    },
  },
};
</script>